var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('categorias-clientes-form',{attrs:{"idCategoriaCliente":_vm.idCategoriaCliente,"idCompany":_vm.idCompany,"pag":_vm.pag}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9a48a6c0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/Configuracion/CategoriasClientes/CategoriaCliente.vue
// module id = VPv/
// module chunks = 4